module.exports = __webpack_public_path__ + "img/basic_skinmask_skinmasktube_202308.75c5eb77.jpg";